// Import model
import { CreateContactRequest } from '../models/CreateContactRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreatePhoneNumberRequest } from '../models/CreatePhoneNumberRequest';

// Import dependency serializers (for complex types)
import { CreatePhoneNumberRequestSerializer } from './CreatePhoneNumberRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateContactRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateContactRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateContactRequest instance
   */
  static deserialize(json: string): CreateContactRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateContactRequest instance
   */
  static fromObject(obj: any): CreateContactRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateContactRequest');
    }


    const instance: CreateContactRequest = {
      role: obj['role'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      state: obj['state'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      country: obj['country'] as string | undefined,
      email: obj['email'] as string | undefined,
      location: obj['location'] as any | undefined,
      parentContactId: obj['parentContactId'] as string | undefined,
      phoneNumbers: obj['phoneNumbers'] ? (obj['phoneNumbers'] as any[]).map((item: any) =>
        CreatePhoneNumberRequestSerializer.fromObject(item)
      ) : [] as any,
      type_: obj['type'] as string,
      name: obj['name'] as string,
      entityId: obj['entityId'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      address2: obj['address2'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateContactRequest instances
   */
  static deserializeArray(json: string): CreateContactRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateContactRequest instance to a JSON string
   */
  static serialize(instance: CreateContactRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateContactRequest instance to a plain object
   */
  static toObject(instance: CreateContactRequest): any {
    return {
      'role': instance.role,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'address': instance.address,
      'city': instance.city,
      'state': instance.state,
      'postalCode': instance.postalCode,
      'country': instance.country,
      'email': instance.email,
      'location': instance.location,
      'parentContactId': instance.parentContactId,
      'phoneNumbers': instance.phoneNumbers?.map((item: any) =>
        CreatePhoneNumberRequestSerializer.toObject(item)
      ),
      'type': instance.type_,
      'name': instance.name,
      'entityId': instance.entityId,
      'notes': instance.notes,
      'address2': instance.address2,
    };
  }

  /**
   * Serializes an array of CreateContactRequest instances to a JSON string
   */
  static serializeArray(instances: CreateContactRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
